import { strToStatus } from '@/_schemas/status-input';

import type { CompetitorFormSchema, CompetitorQuerySchema } from '../schemas';

export function competitorQueryToForm(data: CompetitorQuerySchema): CompetitorFormSchema {
  return {
    ...data,
    name: data?.name ?? '',
    email: data?.email ?? '',
    status: strToStatus(data.status ?? ''),
    business_tagline: data?.business_tagline ?? '',
    number_of_customers: data?.number_of_customers ?? 0,
    founded_date: data?.founded_date ?? '',
    headcount: data?.headcount ?? 0,
    website: data?.website ?? '',
    pricing_strategy: data?.pricing_strategy ?? '',
    tidbits: data?.tidbits ?? '',
    weaknesses: data?.weaknesses ?? '',
    strengths: data?.strengths ?? '',
    how_to_win: data?.how_to_win ?? '',
    glassdoor_url: data?.glassdoor_url ?? '',
    associated_clients_count: data?.associated_clients_count ? data?.associated_clients_count.toString() : '',
    primary_contact_count: data?.primary_contact_count ? data?.primary_contact_count.toString() : '',
    logo: data?.logo ?? [],
  };
}
